import { render, staticRenderFns } from "./ShouyeTop.vue?vue&type=template&id=00855e00&scoped=true&"
import script from "./ShouyeTop.vue?vue&type=script&lang=js&"
export * from "./ShouyeTop.vue?vue&type=script&lang=js&"
import style0 from "./ShouyeTop.vue?vue&type=style&index=0&id=00855e00&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00855e00",
  null
  
)

export default component.exports